import React, {useEffect, useState} from 'react';
import AuthService from "../../../services/auth.service";
import './new_weight.scss';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Loader, Placeholder, Button, Progress, Modal} from "rsuite";
import CloseIcon from "@rsuite/icons/Close";
import HtmlContent from "../elements/dynamic/html-content/htmlContent";
import CardContent from "../elements/dynamic/card/cardContent";
import BackIcon from "../../../img/back.svg";
import ModalContent
    from "../elements/dynamic/modal/modalContent";
import HttpService from "../../../services/HttpService";
import MessageHandle from "../../../services/MessageHandle";

const APP_URL = process.env.APP_URL;
const formData = {}

let myStep = 0;

const NewWeight = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const [currentStep, setCurrentStep] = useState(0);
    const [saveModal, setSaveModal] = useState(false)
    const {setContent} = props;
    let ans = [];

    const [modals, setModals] = useState({});
    const [hasUserForm, setHasUserForm] = useState(0);

    useEffect(() => {
        if (AuthService.getSubscription() && AuthService.getSubscription().is_user_form_update && !AuthService.getReserved()) {
            window.location.replace('/subscriptions');
        }
        sync();
    }, [])



    const [answers, setAnswers] = useState(ans);

    return (<>
        {data ? dashboard() : <div><Placeholder.Paragraph rows={5}/>
            <Loader backdrop content="درحال خواندن اطلاعات شما ..." vertical/></div>}
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
        {data?.finish ?
            <ModalContent modal={data?.finish}
                          updateInfo={save}
                          activeModal={activeModal}
                          handleClose={handleClose}
                          handleEdit={handleClose}
                          getAnswerValueByName={getAnswerValueByName}
                          updateAnswer={updateAnswer}
            />
            : ''
        }
    </>);

    function dashboard() {

        return <div className="new_weight_container">
            <div className="new_weight_wrapper">
                <div className="new_weight_col">
                    <div className="new-weight-bs-dismiss " onClick={() => window.location.href = '/subscriptions'}>
                        <CloseIcon/>
                    </div>

                    <div className="mt-2">
                        {data ? render() : <div><Placeholder.Paragraph rows={5}/>
                            <Loader backdrop content="درحال خواندن اطلاعات شما ..." vertical/></div>}
                    </div>
                </div>
            </div>
        </div>
    }

    function render() {

        return (<div>
            <div className="regime-form-step-counter">
                {data?.steps?.length > 1 ?

                    <>
                        <div className="regime-form-progress-bar">
                            <Progress.Line percent={formData ? ((currentStep + 1) * 100) / data.steps.length : 0}
                                           strokeColor="#F5921F"
                                           showInfo={false}
                            />
                            <div className="regime-form-step-counter">
                                {data ? `${currentStep + 1}/${data.steps.length}` : ''}
                            </div>
                        </div>
                    </>


                    : ''}
            </div>
            {data.steps[currentStep] ? RenderCurrentStep(data.steps[currentStep], currentStep) :
                <>
                    <Placeholder.Paragraph rows={8}/>
                    <Loader backdrop content="درحال بارگذاری ..." vertical/>
                </>
            }


        </div>)
    }

    function RenderCurrentStep(step, index) {

        return (<div>
            {index > 0 ? backButton() : ''}

            {step?.options.map((item, itemIndex) => {
                let view = null;

                if (item.type === 'html') {

                    view = (
                        <HtmlContent
                            key={item.id}
                            style={item?.style}
                            content={item.content}
                        />);

                } else if (item.type === 'card') {
                    view = (
                        <CardContent
                            key={item.id}
                            cardIndex={itemIndex}
                            id={item.id}
                            type={item.type}
                            icon={item.icon}
                            title={item.title}
                            value={item.value}
                            name={item.name}
                            style={item?.style}
                            modal={item?.modal}
                            updateInfo={updateInfo}
                            activeModal={activeModal}
                            handleClose={handleClose}
                            handleOpen={handleOpen}
                            unit={item?.unit ? item.unit : ''}
                            getAnswerValueByName={getAnswerValueByName}
                            updateAnswer={updateAnswer}
                        />)
                }
                return view;
            })
            }
            <div className="mt-2">

                {index + 1 === data.steps.length ?

                    <div className="btn-container">
                        <button
                            className="btn-green mt-2"
                            onClick={(event) => handleOpen(event, 'finish_modal')}>
                            ذخیره تغییرات
                        </button>
                    </div>
                    :
                    <div className="btn-container">
                        <Button appearance={isLoading ? 'default' : 'primary'}
                                loading={isLoading}
                                onClick={handleNext}
                                className={`btn-step-${currentStep + 1} hf-1`}
                                block>
                            ادامه
                        </Button>
                    </div>

                }
            </div>
        </div>)
    }

    function sync() {
        setIsLoading(true)

        HttpService.get(`${APP_URL}/api/v2/dashboards/weighing`)
            .then(function (response) {
                setData(response.data.data);
                setIsLoading(false);
                setDefault(response.data.data)
            })
            .catch(function (error) {
                if (!error.response) {
                    handleNotfound();
                    return false;
                }
                MessageHandle.error(error)
                setIsLoading(false);
            });
    }

    function backButton() {
        return (
            <button className="btn-back" onClick={handleBack}>
                <img src={BackIcon} alt="back" style={{width: '20px'}}/>
            </button>);
    }

    function handleBack() {
        const indexes = Object.keys(data.steps).map(index => parseInt(index));
        const prevStep = currentStep - 1;

        if (indexes.includes(prevStep)) {
            setCurrentStep(prevStep);
        }
    }

    function handleNext(force = true) {
        const indexes = Object.keys(data.steps).map(index => parseInt(index));
        const nextStep = currentStep + 1;

        if (nextStep >= data.steps.length) {
           /* window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'form_v2_completion',
                'step': nextStep,
                'has_form': hasUserForm,
            });*/
            save();
            return true;
        }

        if (indexes.includes(nextStep)) {
            setCurrentStep(nextStep);
            myStep = nextStep;
            /*window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'form_v2_step_change',
                'step': nextStep,
                'has_form': hasUserForm,
            });*/
        }
    }

    function openSaveModal(event) {
        setSaveModal(true)
    }

    function handleOpen(event, modal_name) {
        const updatedModals = {modals};
        updatedModals[modal_name] = true;
        setModals(updatedModals);
    }

    function activeModal(modalState) {
        return modals && modals.hasOwnProperty(modalState) ? modals[modalState] : false;
    }

    function handleClose() {

        const updatedModals = {};
        setModals(updatedModals);

    }

    function updateInfo(event, modalValue) {
        switch (modalValue) {
            case 'activity_level':
                let activity = document.querySelector('input[name="activity_level"]:checked').value;
                formData.activity = activity
                switch (formData.activity) {
                    case '1':
                        formData.activityValue = 'خیلی کم';
                        break;
                    case '2':
                        formData.activityValue = 'کم';
                        break;
                    case '3':
                        formData.activityValue = 'متوسط';
                        break;
                    case '4':
                        formData.activityValue = 'سنگین';
                        break;
                    case '5':
                        formData.activityValue = 'خیلی سنگین';
                        break;
                }
                break;
            case 'target_level':
                let targetLevel = document.querySelector('input[name="target_level"]:checked').value;
                formData.target_level = targetLevel
                switch (formData.target_level) {
                    case '1':
                        formData.targetLevelValue = 'آسان';
                        break;
                    case '2':
                        formData.targetLevelValue = 'متوسط';
                        break;
                    case '3':
                        formData.targetLevelValue = 'سخت';
                        break;
                }
                break;
            case 'target_weight':
                let targetWeight = document.querySelector('input[name="target_weight"]').value;
                formData.target_weight = targetWeight
                break;
            case 'age':
                let age = document.querySelector('input[name="age"]').value;
                formData.age = age
                break;
            case 'gender':
                let gender = document.querySelector('input[name="gender"]:checked').value;
                formData.gender = gender
                if (formData.gender === '1') {
                    formData.genderValue = 'آقا'
                } else {
                    formData.genderValue = 'خانم'
                }
                break;
            case 'allergies':
                let allergies = []
                let selected = document.querySelectorAll('input[name="allergies"]:checked')
                for (let i = 0; i < selected.length; i++) {
                    allergies.push(selected[i].value)
                }
                formData.allergies = allergies
                break;
        }
        changeCurd();
        handleClose();
    }
    function changeCurd(){
        if (formData['activityValue'])document.getElementById('activity_level').innerHTML = formData['activityValue']
        if (formData['targetLevelValue'])document.getElementById('target_level').innerHTML = formData['targetLevelValue']
        if (formData['target_weight'])document.getElementById('target_weight').innerHTML = formData['target_weight']
        if (formData['genderValue'])document.getElementById('gender').innerHTML = formData['genderValue']
        if (formData['allergies'])document.getElementById('allergies').innerHTML = formData['allergies'].length
        if (formData['age'])document.getElementById('age').innerHTML = formData['age']
    }

    function setDefault(response) {
        let currentAnswers = []
        response.steps[0]['options'].map((item, index)=>{
            if (item.modal){
            const name = item.modal['name']
            const value = item.modal['default_value']
                let answer = {};
                answer.name = name;
                answer.value = value

                    currentAnswers.push(answer);
            }
        })
        setAnswers(currentAnswers);

    }
    function updateAnswer(event, type, checked = true) {
        if (isNaN(event.target.value)) {
            event.target.value = ''
            toast.error('لطفا عدد وارد کنید', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        const {name} = event.target;
        const {value} = event.target;

        let currentAnswers = [...answers];
        const targetIndex = currentAnswers.findIndex(answer => answer.name === name);
        const targetAnswer = currentAnswers[targetIndex];

        let answer = {};
        answer.name = name;

        if (type === 'checkbox') {
            if (targetAnswer) {
                answer.value = targetAnswer.value;
            } else {
                answer.value = [];
            }

            if (checked) {
                answer.value.push(value);
            } else {
                answer.value = answer.value.filter(val => val != value).flat();
            }
        } else {
            answer.value = value;
        }

        if (targetAnswer) {
            currentAnswers[targetIndex] = answer;
        } else {
            currentAnswers.push(answer);
        }

        setAnswers(currentAnswers);

        return currentAnswers;
    }

    function getAnswerValueByName(name) {
        const index = answers.findIndex(answer => answer.name === name);

        if (index >= 0) {
            try {
                if (answers[index].value) {
                    if (Array.isArray(answers[index].value)) {
                        return answers[index].value;
                    }

                    return answers[index].value.toString();
                } else {
                    return '';
                }
            } catch (exception) {
                return answers[index].value;
            }
        }

        return false;
    }

    function save() {
        let body = {
            weight: document.getElementById("weight").value,
            ...formData
        };
        HttpService.post(`${APP_URL}/api/user-forms/weighing`, body).then(response => {
            MessageHandle.success(response.data.message)
            window.location.replace('/subscriptions');
        }).catch(function (error) {

                    if (!error.response) {
                        handleNotfound();
                        return false;
                    }

            MessageHandle.error(error)
            setIsLoading(false);

        })
    }

    function closeSaveModal() {
        setSaveModal(false)
    }

    function handleNotfound() {

        localStorage.setItem("error", 'PageNotFound');
        setIsLoading(false);
        //setStep('notfound');
        window.location.href = '';
    }
}
export default NewWeight;
